export default {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    opacity: ({ dimmed }) => (dimmed ? 0.5 : 1),
  },
};
